<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            icon
            color="purple"
            @click="open_dialog"
            :disabled="!telemetryData.telemetries"
            v-bind="attrs"
            v-on="on">
          <v-icon>mdi-state-machine</v-icon>
        </v-btn>
      </template>
      <span>Telemetrie-Daten</span>
    </v-tooltip>
    <v-dialog
        v-model="dialog"
        persistent
        width="1800">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Terminal Telemetrie - {{ telemetryData.name }}
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="get_telemetry_data">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
          <v-btn icon @click="close_dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>

          <v-data-table
              :headers="headers"
              :items="comp_telemetry_data"
              sort-by="created_at desc"
              class="elevation-1"
          >
            <template v-slot:item.created_at="{ item }">
        <span>{{
            new Date(item.created_at.replace(" ", "T")).toLocaleString([], {
              dateStyle: 'short',
              timeStyle: 'short'
            })
          }}</span>
            </template>

          </v-data-table>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="close_dialog"
          >Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'terminalTelemetry',
  props: {
    telemetryData: Object,
  },
  data: () => ({
    dialog: false,
    headers: [
      {text: 'CPU Auslastung(%)', value: 'cpu_usage', align: 'center'},
      {text: 'CPU Temperatur(°C)', value: 'cpu_temperature', align: 'center'},
      {text: 'Speicher Verbrauch', value: 'memory_total', align: 'center'},
      {text: 'Speicher Verwendet(%)', value: 'memory_used_percent', align: 'center'},
      {text: 'Zeit', value: 'created_at', align: 'center'},
    ]
  }),

  computed: {
    comp_telemetry_data() {
      return this.$store.getters['ClubApp/client_terminal_telemetries'];
    }
  },

  methods: {
    async open_dialog() {
      await this.get_telemetry_data();
      this.dialog = true;
    },
    close_dialog() {
      this.dialog = false;
      this.$store.commit('ClubApp/CLEAR_CLIENT_TELEMETRY');
    },
    async get_telemetry_data() {
      const Data = {
        client_id: this.telemetryData.id,
      };
      await this.$store.dispatch('ClubApp/getTerminalTelemetries', Data);
    }
  }


}

</script>

<style scoped>

</style>